import React from 'react'
import moment from 'moment-timezone'
import clsx from 'clsx'
import {UploadHistoryStatus} from '../../../../../../services/cellcast.type'
import './UploadHistoryMobileCard.scss'

interface UploadHistoryItem {
  _id?: string
  filekey?: string
  totalContact?: string | number
  importedContact?: string | number
  duplicatedContact?: string | number
  invalidContact?: string | number
  createdAt?: string
  status?: UploadHistoryStatus
  originalName?: string
}

interface UploadHistoryMobileCardProps {
  item: UploadHistoryItem
}

export const UploadHistoryMobileCard: React.FC<UploadHistoryMobileCardProps> = ({item}) => {
  const status = item?.status
  const badgeClass = clsx('badge fw-bold', {
    'badge-light-success': status === UploadHistoryStatus.COMPLETED,
    'badge-light-danger': status === UploadHistoryStatus.FAILED,
    'badge-light-warning': status === UploadHistoryStatus.QUEUED,
    'badge-light-primary': status === UploadHistoryStatus.INPROGRESS,
  })

  const fileName = item?.originalName
    ? item.originalName
    : item?.filekey?.split('/').at(1) || '-'

  return (
    <div className='upload-history-mobile-card'>
      {/* Header: Filename + Status */}
      <div className='card-header-section'>
        <div className='file-info'>
          <div className='file-name'>
            <i className='bi bi-file-earmark me-2'></i>
            <span className='text-truncate' title={fileName}>
              {fileName}
            </span>
          </div>
          <div className='status-badge'>
            <span className={badgeClass}>{item?.status?.toUpperCase() || '-'}</span>
          </div>
        </div>
      </div>

      {/* Upload Date */}
      {item?.createdAt && (
        <div className='card-date-section mb-3'>
          <div className='date-item'>
            <i className='bi bi-calendar3 me-2'></i>
            <span className='text-muted small'>
              Uploaded: {moment(item.createdAt).format('MMM DD, YYYY h:mm A')}
            </span>
          </div>
        </div>
      )}

      {/* Stats Grid */}
      <div className='card-stats-grid'>
        <div className='stat-item'>
          <div className='stat-label'>
            <i className='bi bi-people me-1'></i>
            Total Contact
          </div>
          <div className='stat-value'>{item?.totalContact ?? '-'}</div>
        </div>
        <div className='stat-item'>
          <div className='stat-label'>
            <i className='bi bi-check-circle me-1'></i>
            Imported
          </div>
          <div className='stat-value text-success'>{item?.importedContact ?? '-'}</div>
        </div>
        <div className='stat-item'>
          <div className='stat-label'>
            <i className='bi bi-files me-1'></i>
            Duplicate
          </div>
          <div className='stat-value text-warning'>{item?.duplicatedContact ?? '-'}</div>
        </div>
        <div className='stat-item'>
          <div className='stat-label'>
            <i className='bi bi-x-circle me-1'></i>
            Invalid
          </div>
          <div className='stat-value text-danger'>{item?.invalidContact ?? '-'}</div>
        </div>
      </div>
    </div>
  )
}

